
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 76.28 122.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M71.63 12.8h-67v16.55a33.42 33.42 0 0015.09 28c4 2.64 4 4.94 0 7.58a33.42 33.42 0 00-15.09 28v16.56h67V92.86a33.41 33.41 0 00-15.09-28c-4-2.64-4-4.94 0-7.58a33.41 33.41 0 0015.09-28z","fill":"#fff"}}),_c('path',{attrs:{"fill":"#08379e","d":"M4.65 8.98h66.98v4.1H4.65z"}}),_c('path',{attrs:{"d":"M72.53 0H3.76A3.76 3.76 0 000 3.76v1.46a3.76 3.76 0 003.76 3.76h68.77a3.76 3.76 0 003.76-3.76V3.76A3.76 3.76 0 0072.53 0z","fill":"#1b61dd"}}),_c('path',{attrs:{"fill":"#08379e","d":"M4.65 109.42h66.98v4.1H4.65z"}}),_c('rect',{attrs:{"y":"113.52","width":"76.28","height":"8.98","rx":"3.76","ry":"3.76","fill":"#1b61dd"}}),_c('path',{attrs:{"d":"M43.14 76.39V56.21a28.29 28.29 0 0023.28-27.8H9.88a28.29 28.29 0 0023.28 27.8h-.24l.24 20.19a28.3 28.3 0 00-23.28 27.8h56.54a28.31 28.31 0 00-23.28-27.81z","fill":"#f38e0d"}})])
          )
        }
      }
    